module.exports = __webpack_public_path__ + "static/changehero-f58492bfbf792e030e17adeb3051fd78.png";